let API_URL = (process.env.REACT_APP_FASTAPI_URL || '').trim();

console.log('Config: Initial API_URL:', API_URL);

if (typeof window !== 'undefined') {
    console.log('Config: Current Protocol:', window.location.protocol);

    try {
        // Only attempt upgrade if we are on HTTPS and the API URL is HTTP
        if (window.location.protocol === 'https:' && API_URL.startsWith('http:')) {
            const urlObj = new URL(API_URL);
            if (urlObj.protocol === 'http:') {
                urlObj.protocol = 'https:';
                API_URL = urlObj.toString();
                // Remove trailing slash if it was added by toString() but wasn't there before (optional preference)
                if (API_URL.endsWith('/') && !process.env.REACT_APP_FASTAPI_URL.endsWith('/')) {
                    API_URL = API_URL.slice(0, -1);
                }
                console.log('Config: Upgraded API_URL to HTTPS:', API_URL);
            }
        }
    } catch (error) {
        console.error('Config: Error parsing/upgrading API URL:', error);
    }
}

export { API_URL };
